<template>
  <div>
    <a-modal
      title="选择模型"
      :width="640"
      :visible="visible"
      ok-text="确认"
      cancel-text="取消"
      @ok="
        () => {
          $emit('ok');
        }
      "
      @cancel="
        () => {
          $emit('cancel');
        }
      "
    >
      <!-- <a-spin :spinning="loading"> -->
        <a-form :form="form" v-bind="formLayout">
          <a-form-item label="模型">
            <a-select
              show-search
              placeholder="请选择下载模型"
              v-decorator="['projectId']"
            >
              <a-select-option v-for="p in modelList" :key="p.name">
                {{ p.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-form>
      <!-- </a-spin> -->
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    // loading: {
    //   type: Boolean,
    //   default: () => false,
    // },
    model: {
      type: Object,
      default: () => null,
    },
    visible: {
      type: Boolean,
      required: true,
    },
    modelList: {
      type: Array,
      default: () => null,
    },
  },
  data() {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 },
      },
    };
    return {
      form: this.$form.createForm(this),
      headers: {},
    };
  },
};
</script>

<style lang="scss" scoped>
</style>